import { useContext, useEffect, memo } from 'react';
import { Context as AuthContext } from '../../Redux/context/AuthContext';
import { useHistory, useLocation } from 'react-router-dom';
import useQueryParams from './Hooks/useQueryParams';

const AdminAuthorizedPage = () => {
  const { supplierLogin } = useContext(AuthContext);

  let history = useHistory();
  let location = useLocation();
  const { token, supplier_id, role, falconBusinessType, sellerName } = useQueryParams();
  const handleSupplierLogin = async () => {
    let { from } = location.state || {
      from: { pathname: '/dashboard' },
      state: { source: 'From admin login' },
    };
    await supplierLogin({ token, supplier_id, role, falconBusinessType, sellerName });
    console.log('from', from);
    history.replace(from);
    window.location.reload();
  };

  useEffect(() => {
    console.log('useeee', token, supplier_id, role);
    if (token && supplier_id && role) {
      handleSupplierLogin();
    }
  }, [token, supplier_id, role]);

  return <div>Loading...</div>;
};
export default memo(AdminAuthorizedPage);
